import i18next from "i18next";
import { dateFormat } from "../../helpers/date";
import { defineProperties } from "../../translationService";
import createEntityScreen from "../layout/connectedEntityScreen";
export var paymentScreenColumns = [
    defineProperties({ key: "billid" }, { label: 'user_entity.payments.bill_id', }),
    defineProperties({ key: "type" }, { label: 'user_entity.payments.payment_type', }),
    defineProperties({ key: "finalizedat" }, { label: 'user_entity.payments.finalized_at', }),
    defineProperties({ key: "amount", align: "right" }, { label: 'user_entity.payments.payment_amount', }),
];
export var UserPaymentsScreen = createEntityScreen({
    entityName: 'payments',
    columnHeaders: paymentScreenColumns,
    columnConfiguration: "userPaymentsColumns",
    renderCell: function (record, column, wrapFunction) {
        switch (column) {
            case "finalizedat": return wrapFunction(record[column] && dateFormat(record[column], i18next.t("user_entity.payments.finalized_at_format")));
        }
        return wrapFunction(record[column]);
    },
});
